import styled from '@emotion/styled';
import { Button, Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;

  &:not(:hover) {
    .hover {
      opacity: 0.25;
    }

    & > .hover {
      transition: opacity 0.15s ease-in-out;
    }
  }
`;

export const FileNameWrapper = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.onTop};
  top: 8px;
  left: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};

  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
`;

export const ButtonFileChange = styled(Button)`
  position: absolute;
  z-index: ${Z_INDEX.onTop};
  top: 50px;
  left: 8px;
`;

export const FlexPdfViewerWrapper = styled(Flex)`
  position: relative;
  height: 289px;
  background-color: ${({ theme }) => theme.colors.zinc_400};
`;
